<div class="transfer-form-container">
  <form *ngIf="transferForm" [formGroup]="transferForm" (ngSubmit)="onSubmit()" class="transfer-form">
    <div class="form-group">
      <label class="form-label required">
        {{ 'pages.stock.transfer.select_source_warehouse' | translate }} *
      </label>
      <div class="select-container">
        <select [formControl]="transferForm.controls.sourceStoreId" class="form-control" [class.disabled]="true">
          <option [value]="stockData.stock.storeId">{{ stockData.stock.storeName }}</option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label required">
        {{ 'pages.stock.transfer.select_destination_warehouse' | translate }} *
      </label>
      <div class="select-container">
        <select [formControl]="transferForm.controls.destinationStoreId" class="form-control"
          [disabled]="isLoadingStores">
          <option value="" disabled>
            {{ isLoadingStores ? ('common.loading' | translate) : ('pages.stock.transfer.select_warehouse' | translate)
            }}
          </option>
          <option *ngFor="let store of availableStores" [value]="store.id">
            {{ store.name }}
          </option>
        </select>
      </div>
      <div *ngIf="transferForm.controls.destinationStoreId.invalid && transferForm.controls.destinationStoreId.touched"
        class="error-message">
        {{ 'pages.stock.transfer.destination_required' | translate }}
      </div>
    </div>

    <div class="quantity-section">
      <h4 class="quantity-title">{{ 'pages.stock.transfer.how_many_units_to_move' | translate }}</h4>
      <div class="quantity-controls">
        <button type="button" class="quantity-btn minus" (click)="decreaseQuantity()" [disabled]="quantity <= 1">
          -
        </button>
        <input type="number" formControlName="quantity" (input)="onQuantityChange()" class="quantity-input" min="1"
          [max]="stockAvailable" step="1">
        <button type="button" class="quantity-btn plus" (click)="increaseQuantity()"
          [disabled]="quantity >= stockAvailable">
          +
        </button>
      </div>
    </div>

    <div class="transfer-summary" *ngIf="selectedStore && quantity > 0">
      <div class="summary-row">
        <span class="summary-label">{{ 'pages.stock.transfer.source' | translate }}:</span>
        <span class="summary-value">
          {{ stockData.stock.storeName }}
          <span class="quantity-change">{{ stockData.lot.stockQuantity }} → {{ remainingQuantity }}</span>
        </span>
      </div>
      <div class="summary-row">
        <span class="summary-label">{{ 'pages.stock.transfer.destination' | translate }}:</span>
        <span class="summary-value">
          {{ selectedStore.name }}
          <span class="quantity-change">{{ getDestinationCurrentStock() }} → {{ getDestinationFinalStock() }}</span>
        </span>
      </div>
    </div>

    <div class="form-actions">
      <!-- <button type="button" class="btn-secondary" (click)="goBack()" [disabled]="isLoading">
        {{ 'common.back' | translate }}
      </button> -->
      <button type="submit" class="btn-primary" [disabled]="transferForm.invalid || isLoading || isLoadingStores">
        <span *ngIf="isLoading" class="loading-spinner"></span>
        {{ 'pages.stock.transfer.save_changes' | translate }}
      </button>
    </div>
  </form>
</div>